import { Dispatch } from "redux";
import { ACTION_TYPES } from "../../constants/actionTypes";
import { ACHIEVEMENT_TYPES } from "../../constants/gamification/achievementTypes";
import {
  getUserAchievements as getUserAchievementsApi,
  completeTutorial as completeTutorialApi,
} from "@api/gamification/achievement";

/********************************************
  Get user achievements action
*********************************************/
export const getUserAchievementsAction = () => async (dispatch: Dispatch) => {
  // Dispatch loading alert
  dispatch({
    type: ACTION_TYPES.ALERT,
    payload: { loading: true },
  });

  try {
    // Fetch response from server
    const res = await getUserAchievementsApi();

    // Dispatch achievements
    dispatch({
      type: ACHIEVEMENT_TYPES.GET_USER_ACHIEVEMENTS,
      payload: res.data,
    });

    // Dispatch success alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: false },
    });

    return res.data;
  } catch (error) {
    // Dispatch error alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: {
        message: "GET_USER_ACHIEVEMENTS_ACTION_ERROR",
        loading: false,
      },
    });

    throw error;
  }
};

/********************************************
  Complete tutorial action
*********************************************/
export const completeTutorialAction =
  (tutorialId: string) => async (dispatch: Dispatch) => {
    // Dispatch loading alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      // Fetch response from server
      const res = await completeTutorialApi({ tutorialId });

      // Dispatch tutorial completion
      dispatch({
        type: ACHIEVEMENT_TYPES.COMPLETE_TUTORIAL,
        payload: res.data,
      });

      // Dispatch success alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          loading: false,
          success: true,
          message: `Tutorial completed! You earned ${res.data.creditsEarned} credits.`,
        },
      });

      return res.data;
    } catch (error: any) {
      // Dispatch error alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: error.response?.data?.message || "Error completing tutorial",
          loading: false,
        },
      });

      throw error;
    }
  };